import { render, staticRenderFns } from "./Tab3Treatment_etc.vue?vue&type=template&id=5eaabc8c&scoped=true&"
import script from "./Tab3Treatment_etc.vue?vue&type=script&lang=js&"
export * from "./Tab3Treatment_etc.vue?vue&type=script&lang=js&"
import style0 from "./Tab3Treatment_etc.vue?vue&type=style&index=0&id=5eaabc8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaabc8c",
  null
  
)

export default component.exports